import { render } from "./CustomerMatrix.vue?vue&type=template&id=656b9a0b&scoped=true"
import script from "./CustomerMatrix.vue?vue&type=script&lang=js"
export * from "./CustomerMatrix.vue?vue&type=script&lang=js"

import "./CustomerMatrix.vue?vue&type=style&index=0&id=656b9a0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656b9a0b"]])

export default __exports__